import { render, staticRenderFns } from "./EditProspectDetails.vue?vue&type=template&id=d182991a&"
import script from "./EditProspectDetails.vue?vue&type=script&lang=js&"
export * from "./EditProspectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports